<template>
    <div :class="['ui-state', compact ? 'ui-state--compact' : '']" role="status" aria-live="polite">
        <div v-if="loading" class="ui-state__spinner" aria-hidden="true"></div>
        <i v-else class="material-icons ui-state__icon" aria-hidden="true">{{ iconName }}</i>
        <div class="ui-state__content">
            <div class="ui-state__title">{{ resolvedTitle }}</div>
            <p v-if="resolvedMessage" class="ui-state__message">{{ resolvedMessage }}</p>
            <button v-if="actionLabel" type="button" class="ui-state__action" @click="$emit('action')">
                {{ actionLabel }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: "empty",
        },
        title: {
            type: String,
            default: "",
        },
        message: {
            type: String,
            default: "",
        },
        actionLabel: {
            type: String,
            default: "",
        },
        compact: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        loading() {
            return this.type === "loading"
        },
        iconName() {
            const icons = {
                empty: "inbox",
                error: "error_outline",
                success: "check_circle",
            }
            return icons[this.type] || icons.empty
        },
        resolvedTitle() {
            if (this.title) return this.title
            if (this.type === "loading") return "Loading"
            if (this.type === "error") return "Something went wrong"
            return "No data found"
        },
        resolvedMessage() {
            if (this.message) return this.message
            if (this.type === "loading") return "Please wait while the latest data loads."
            if (this.type === "error") return "Try again or refresh the page if the issue continues."
            return ""
        },
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.ui-state {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
    width: 100%;
    min-height: 160px;
    padding: 24px;
    color: $textColor;
    text-align: left;

    &--compact {
        min-height: 92px;
        padding: 16px;
    }
}

.ui-state__spinner {
    width: 32px;
    height: 32px;
    border: 3px solid rgba(13, 45, 44, 0.16);
    border-top-color: $primaryColor;
    border-radius: 50%;
    animation: ui-state-spin 0.8s linear infinite;
    flex: 0 0 auto;
}

.ui-state__icon {
    color: $primaryColor;
    font-size: 36px;
}

.ui-state__title {
    color: $primaryColor;
    font-size: 15px;
    font-weight: 700;
}

.ui-state__message {
    margin: 4px 0 0;
    color: rgba($textColor, 0.72);
    font-size: 13px;
}

.ui-state__action {
    margin-top: 12px;
    border: 1px solid $primaryColor;
    border-radius: 6px;
    background: $primaryColor;
    color: #fff;
    font-size: 13px;
    font-weight: 700;
    padding: 8px 12px;
}

@keyframes ui-state-spin {
    to {
        transform: rotate(360deg);
    }
}
</style>
